<div role="grid" class="datepicker-table" #datepickerTableRef>
  <div role="row" class="datepicker-tablehead datepicker-tablerow">
    @for (weekday of weekdays; track $index; let i = $index) {
      <span
        role="columnheader"
        class="datepicker-tablecell"
        [attr.aria-label]="weekdaysFull[i]"
      >
        {{ weekday }}
      </span>
    }
  </div>
  <div role="presentation">
    <div role="rowgroup" class="datepicker-tablebody">
      @for (week of days; track $index) {
        <tr role="row" class="datepicker-tablerow">
          @for (day of week; track $index) {
            <button
              type="button"
              class="datepicker-tablecell"
              [class.selected]="!day.otherMonth && day.date === initialDate"
              [attr.aria-selected]="!day.otherMonth && day.date === initialDate"
              [attr.disabled]="isDisabled(day) ? '' : undefined"
              (click)="selectDate(day)"
              [attr.id]="isDisabled(day) ? undefined : 'day-' + day.date"
              [attr.aria-label]="
                isDisabled(day) ? undefined : getDateLocale(day.date)
              "
              tabindex="-1"
              role="gridcell"
            >
              {{ day.otherMonth ? '' : day.date }}
            </button>
          }
        </tr>
      }
    </div>
  </div>
</div>
